<template>
    <!-- 내 하부 유저의 활동으로 인한 보상 내역 -->
    <section>
        <div class="searchDate">
            <label>날짜 선택</label>
            <div class="input-group">
                <flat-pickr
                    v-model="date"
                    :config="config"                                                          
                    class="form-control" 
                    placeholder="Select date"               
                    name="date"
                    @on-change="fetchLists">
                </flat-pickr>
                <!-- <div class="input-group-append">
                    <button class="btn btn-default" type="button" title="Toggle" data-toggle>
                        <i class="fa fa-calendar">
                        <span aria-hidden="true" class="sr-only">Toggle</span>
                        </i>
                    </button>
                    <button class="btn btn-default" type="button" title="Clear" data-clear>
                        <i class="fa fa-times">
                        <span aria-hidden="true" class="sr-only">Clear</span>
                        </i>               
                    </button>
                </div> -->
            </div>
        </div>
        <!-- <pre>Selected date is - {{date}}</pre> -->
    </section>
    
    <!-- 추천인 적립 보상 기록 -->
    <section>
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <div class="tbl_wrap" v-else>
            <table class="tbl">
                <colgroup>
                    <col style="width:10%" />
                    <col style="width:20%" />
                    <col style="*" />
                    <col style="width:20%" />
                </colgroup>
                <thead>
                    <tr>                         
                        <th class="txt-center">추천인</th>
                        <th>포인트쿠폰</th>
                        <th>닉네임변경</th>
                        <th>글 작성</th>
                        <th>출석</th>
                        <th>댓글</th>
                        <th>게시글추천</th>
                        <th>지급일</th>
                    </tr>
                </thead>   
                <tbody>
                    <template v-if="pointLogs.length ===0">
                        <tr><td colspan="8">내역이 없습니다.</td></tr>                    
                    </template>
                    <template v-else>
                        <tr v-for="(log, index) in pointLogs" :key="index">                         
                            <td class="article_writer">{{log.user.nic}}</td>                          
                            <td>{{log.point_coupon}}</td>
                            <td>{{log.change_nic}}</td>
                            <td>{{log.post_write}}</td>
                            <td>{{log.attendance}}</td>
                            <td>{{log.comment_answer}}</td>
                            <td>{{log.recommend}}</td>
                            <td><display-time :time="log.created_at"/></td>
                        </tr>   
                        <tr class="listSum">
                            <td>합계</td>
                            <td>{{listSum.point_coupon.toFixed(2)}}</td>
                            <td>{{listSum.change_nic.toFixed(2)}}</td>
                            <td>{{listSum.post_write.toFixed(2)}}</td>
                            <td>{{listSum.attendance.toFixed(2)}}</td>
                            <td>{{listSum.comment_answer.toFixed(2)}}</td>
                            <td>{{listSum.recommend.toFixed(2)}}</td>
                            <td>Total: <strong>{{listSum.total.toFixed(2)}}</strong></td>
                        </tr>
                        <tr class="totalSum">
                            <td>총 합계</td>
                            <td>{{rewardTotal.total_point_coupon}}</td>
                            <td>{{rewardTotal.total_change_nic}}</td>
                            <td>{{rewardTotal.total_post_write}}</td>
                            <td>{{rewardTotal.total_attendance}}</td>
                            <td>{{rewardTotal.total_comment_answer}}</td>
                            <td>{{rewardTotal.total_recommend}}</td>
                            <td>Total: <strong>{{rewardTotal.total_all}}</strong></td>
                        </tr>
                    </template>
                   
                </tbody>     
            </table>        
        </div>
       
    </section>
</template>
<script>
import { myRecommenderReward } from '@/components/mixins/pages/myRecommenderReward.js'
export default {
    name: 'yourComponent',
    data () {
      return {
       
      }
    },
    mixins:[myRecommenderReward]
   
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
.searchDate{
    padding:20px;
    display:flex;
    justify-content: center;
     label{
        display: flex;
        align-items: center;
        font-size:14px;
        font-weight: bold;
        padding-right:10px;
    }
    .input-group{
        width:300px;         
        input{
            border: 1px solid #ccc;            
            text-align: center !important;
        }   
    }
}
.listSum{
    background:#000;
    td{
        color:#fff !important;
        strong{
            color:aqua;
        }
    }    
}
</style>